.SearchFiltersContainer
    position: fixed
    right: 0
    top: 0
    height: 100%
    width: 100%
    font-size: 14px
    background: rgb($globalSettingsBackgroundPrimary)
    box-shadow: $globalSettingsShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalSettingsShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05)
    z-index: $indexFilter
    transition: width 250ms ease-in-out
    overflow: hidden
    .SearchFiltersContainerInner
        height: 100%
        min-width: 100%
        box-sizing: border-box
        display: flex
        flex-direction: column
        overflow: hidden
        justify-content: space-between
        .ContentContainer
            width: 100%
            display: flex
            flex-grow: 1
            flex-direction: column
            box-sizing: border-box
        .ButtonsContainer
            width: 100%
            display: flex
            flex-direction: column
            flex-shrink: 0
        .FiltersHeaderContainer
            width: 100%
            padding: 20px
            box-sizing: border-box
            flex-shrink: 0
        .FiltersContainer
            position: relative
            width: calc(100% - 10px)
            overflow-x: hidden
            overflow-y: auto
            flex-grow: 1
            margin-right: 10px // to not interfere with site scroll
            .FiltersContainerInner
                position: absolute
                top: 0
                bottom: 0
                left: 0
                right: 0
                min-height: 0
                display: flex
                flex-direction: column
                gap: 20px
                .FiltersTagsContainer, .FiltersSortContainer
                    width: 100%
                    display: flex
                    flex-direction: column
                    align-items: flex-start
                    overflow: hidden

            .FiltersAccordionContainer
                width: 100%
                color: rgb($globalSettingsFontPrimary)
                stroke: rgb($globalSettingsFontPrimary)
                .AccordionHeader
                    width: 100%
                    display: flex
                    justify-content: space-between
                    align-items: center
                    padding: 10px 20px
                    box-sizing: border-box
                    cursor: pointer
                    background: rgb($globalSettingsBackgroundPrimary)
                    transition: background 250ms ease-in-out
                    span
                        display: flex
                        align-items: center
                        gap: 5px
                    &:hover
                        background: rgb($globalSettingsBackgroundTertiary)
                    .AccordionHeaderRight
                        display: flex
                        font-weight: 700
                        align-items: center
                        gap: 15px
                        text-align: right

                .AccordionSlot
                    width: 100%
                    padding: 0 20px
                    box-sizing: border-box
                    overflow: hidden
                    transition: max-height 250ms ease-in-out


.HiddenFilters
    width: 0

@media #{$tablet}
    .SearchFiltersContainer
        width: 360px
        .SearchFiltersContainerInner
            min-width: 360px
    .HiddenFilters
        width: 0
